import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class ViewportService {
	// Indicates whether the current viewport is considered mobile
	private isMobile = false;
	private readonly MOBILE_BREAKPOINT = 1024;

	constructor() {
		this.checkViewport();
		window.addEventListener('resize', () => this.checkViewport());
	}

	/**
	 * Checks the current window width and updates the isMobile flag.
	 */
	private checkViewport(): void {
		this.isMobile = window.innerWidth < this.MOBILE_BREAKPOINT;
	}

	/**
	 * Returns whether the current viewport is mobile.
	 * Can be used to adapt components based on screen size.
	 */
	isMobileView(): boolean {
		return this.isMobile;
	}
}
